import React, {Component, PropTypes} from 'react';
import Drawer from 'material-ui/Drawer';
import {List, ListItem, MakeSelectable} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import {spacing, typography, zIndex} from 'material-ui/styles';
import {cyan500} from 'material-ui/styles/colors';
import {Areas,AreaRegions} from '../config'
import locale from '../locale'

const SelectableList = MakeSelectable(List);

const styles = {
  logo: {
    cursor: 'pointer',
    fontSize: 24,
    color: typography.textFullWhite,
    lineHeight: `${spacing.desktopKeylineIncrement}px`,
    fontWeight: typography.fontWeightLight,
    backgroundColor: cyan500,
    paddingLeft: spacing.desktopGutter,
    marginBottom: 8,
  },
  version: {
    paddingLeft: spacing.desktopGutterLess,
    fontSize: 16,
  },
};



class AppNavDrawer extends Component {
  static propTypes = {
    docked: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    onChangeList: PropTypes.func.isRequired,
    onRequestChangeNavDrawer: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    style: PropTypes.object,
  };

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  state = {
  };

  handleRequestChangeLink = (event, value) => {
    window.open(value,'_blank');
    // window.location = value;
  };

  handleTouchTapHeader = () => {
    this.context.router.push('/');
    this.props.onRequestChangeNavDrawer(false);
  };

  render() {
    const {
      me,
      location,
      docked,
      onRequestChangeNavDrawer,
      onChangeList,
      open,
      style,
    } = this.props;
    return (
      <Drawer
        style={style}
        docked={docked}
        open={open}
        onRequestChange={onRequestChangeNavDrawer}
        containerStyle={{zIndex: zIndex.navDrawer - 100}}
      >
        <div style={styles.logo} onTouchTap={this.handleTouchTapHeader}>
           {locale.R.title}
        </div>
        <SelectableList
          value={location.pathname}
          onChange={onChangeList}
        >
          <ListItem primaryText={locale.R.news} value="/news" />

          {Areas.map((area,areaIndex)=>(
              <ListItem
                key={area}
                primaryText={locale.get(area)}
                primaryTogglesNestedList={true}
                nestedItems={
                  AreaRegions[area].map((region,regionIndex)=>
                    <ListItem key={region} primaryText={locale.get(region)} value={'/region/'+areaIndex+'-'+regionIndex} />)
                }
              />
          ))}

          <Divider />
        </SelectableList>
        <SelectableList
          value=""
          onChange={this.handleRequestChangeLink}
        >
          <Subheader>{locale.R.Links}</Subheader>
          {me.role && <ListItem primaryText={locale.R.LinkAdmin} value="/admin/" />}
          <ListItem primaryText={locale.R.LinkRebolt} value="https://www.facebook.com/TaiwanRebolt" />
          <ListItem primaryText={locale.R.LinkSphere} value="/sphere/" />
        </SelectableList>
      </Drawer>
    );
  }
}

export default AppNavDrawer;



/** WEBPACK FOOTER **
 ** ./src/app/components/AppNavDrawer.js
 **/